import React from "react";
import { Field, reduxForm } from "redux-form";
import { Stack, PrimaryButton } from "@fluentui/react";
import * as FormHepler from "./formHelper";
import * as Validations from "./validation";

const StockRateUpdateForm = (props) => {
  const { handleSubmit } = props;

  return (
    <form onSubmit={handleSubmit} noValidate className="admin-forms">
      <Stack tokens={{ childrenGap: 15 }}>
        <Stack tokens={{ childrenGap: 15 }}>
          <Field
            name="rate"
            label="Rate"
            type="number"
            required
            validate={[Validations.required, Validations.isNumber]}
            component={FormHepler.RenderTextField}
          />
        </Stack>
        <div className="form-actions">
          <PrimaryButton type="submit">Update Rate</PrimaryButton>
        </div>
      </Stack>
    </form>
  );
};

const StockRateUpdateFormMapped = reduxForm({
  form: "stockRateUpdateForm",
  enableReinitialize: true,
})(StockRateUpdateForm);

export default StockRateUpdateFormMapped;
